import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { TranslationKey, TranslationsFunc } from '../types';

const MISSING_COPY_PREFIX = '**NO-TEXT-FOUND-FOR:';

export const isMissingCopy = (text: string) => text.startsWith(MISSING_COPY_PREFIX);

const getDefaultMessage = (id: TranslationKey) => `${MISSING_COPY_PREFIX} ${id}**`;

export const useTranslations = () => {
  const { formatMessage, ...rest } = useIntl();

  const t: TranslationsFunc = useCallback(
    (id, values, options) =>
      formatMessage({ id, defaultMessage: getDefaultMessage(id) }, values, options),
    [formatMessage]
  );

  return {
    ...rest,
    t,
  };
};
